{
  "id": "rover-s",
  "name": "Ровер-S (малый тротуарный)",
  "drive": "differential",
  "mass_kg": 35,
  "payload": { "max_kg": 15, "cg_offset_m": [0, 0.15, 0] },
  "dimensions_m": { "l": 0.7, "w": 0.55, "h": 0.6 },
  "wheelbase_m": 0.45,
  "track_m": 0.48,
  "cg_height_m": 0.22,
  "clearance_m": 0.08,

  "max_speed_ms": 1.6,
  "max_reverse_ms": 0.5,
  "max_accel_ms2": 0.8,
  "max_decel_ms2": 2.0,
  "emergency_decel_ms2": 3.5,
  "drive_latency_ms": 80,

  "turn_rate_max_dps": 90,
  "turn_rate_at_max_speed": 0.35,
  "turn_accel_dps2": 180,

  "max_obstacle_height_m": 0.06,
  "max_safe_slope_deg": 12,

  "cameras": [
    {
      "id": "front",
      "label": "Камера 1 (передняя)",
      "short": "Front",
      "ui_slot": 2,
      "fov_deg": 110,
      "res": [1280, 720],
      "fps": 30,
      "pos": [0, 0.55, 0.3],
      "pitch_deg": -10
    },
    {
      "id": "rear",
      "label": "Камера 2 (задняя)",
      "short": "Rear",
      "ui_slot": 1,
      "fov_deg": 110,
      "res": [1280, 720],
      "fps": 30,
      "pos": [0, 0.5, -0.3],
      "pitch_deg": -14,
      "yaw_deg": 180
    }
  ],
  "camera_switch_delay_ms": 300,
  "poses": [],

  "control": {
    "command_rate_hz": 20,
    "dead_zone": 0.08,
    "sensitivity_exp": 1.6,
    "release_ramp_ms": 250,
    "dead_man_switch": false
  },

  "failsafe": { "command_ttl_ms": 300, "link_loss_stop_ms": 800 },

  "calibration": {
    "version": "0.1",
    "date": null,
    "tolerance_pct": null,
    "source": "предварительные значения из ТЗ, замеры на реальном роботе не проводились"
  }
}
